export default __webpack_public_path__ + "static/media/landscape19.cb5a0bbb.JPG";